import { OCR } from '@/api/ocr/type'

interface ITaskStateMap {
  label: string
  icon: string
}

export const taskStateMap: Record<OCR.ETaskState, ITaskStateMap> = {
  [OCR.ETaskState.Loading]: {
    label: '待识别',
    icon: 'icon_task_waiting'
  },
  [OCR.ETaskState.Working]: {
    label: '识别中',
    icon: 'icon_task_working'
  },
  [OCR.ETaskState.Done]: {
    label: '识别完成',
    icon: 'icon_task_success'

  },
  [OCR.ETaskState.Fail]: {
    label: '识别失败',
    icon: 'icon_task_fail'
  },
}

export const languageOptions = [
  {
    value: 'cn_common',
    label: '中文'
  },
  {
    value: 'en_common',
    label: '英文'
  },
  // {
  //   value: 'ko_common',
  //   label: '韩文'
  // },
  // {
  //   value: 'jp_common',
  //   label: '日文'
  // }
]

export type tabNames = 'textOCR' | 'fileOCR' | 'listOCR'
